export default __webpack_public_path__ + "static/media/text.be7ae6ce.svg";